export class Slide {
  _id: string;
  image: string = '';
  content: string = '';
  background: string = '';
  backgroundPosition: 'top' | 'bottom' | 'left' | 'right' | 'center' = 'center';
  mode: 'img-txt' | 'txt-img' | 'img' | 'txt' = 'img-txt';
  position: number = 0;
  active: boolean = false;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/shared/slide.model.ts